import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Claim from '@/components/Claim'
import FuseBreed from '@/components/FuseBreed'
import Shop from '@/components/Shop'
import oldUnstake from '@/components/oldUnstake'

import Gallery from '@/components/Gallery'

import dbSearch from '@/components/Store/dbSearch'

import VXHome from '@/components/VX'
import VXMint from '@/components/Vx/Mint'

import Casino from '@/components/Casino'
import TopUp from '@/components/TopUp'



//vx claims
import Mutant from '@/components/MutantVx/Mutant'
import Fusion from '@/components/FusionVx/Fusion'
import Baby from '@/components/babyVX/Baby'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: VXHome
    },
    {
      path: '/VxMint',
      name: 'VxMint',
      component: VXMint
    }, 
    //vxClaims
    {
      path: '/MutantVxClaim',
      name: 'MutantVxClaim',
      component: Mutant,
    },
    {
      path: '/FusionVxClaim',
      name: 'FusionVxClaim',
      component: Fusion,
    },
    {
      path: '/BabyVxClaim',
      name: 'BabyVxClaim',
      component: Baby,
    },
    //
    {
      path: '/Homepage',
      name: 'oldHome',
      component: Home
    },
    {
      path: '/Loadup',
      name: 'Load Up',
      component: TopUp
    },
    {
      path: '/CutBlackjack',
      name: 'Blackjack',
      component: Casino
    },
    {
      path: '/About',
      name: 'About',
      component: About
    },
    {
      path: '/Claim',
      name: 'Claim',
      component: Claim
    },
    {
      path: '/Fuse-Breed',
      name: 'FuseBreed',
      component: FuseBreed
    },
    {
      path: '/Shop',
      name: 'Shop',
      component: Shop
    },
    {
      path: '/Gallery',
      name: 'Gallery',
      component: Gallery
    },
    {
      path: '/oldUnstake',
      name: 'oldUnstake',
      component: oldUnstake
    },
    {
      path: '/onlyForIvanaDBSearch',
      name: 'onlyForIvanaDBSearch',
      component: dbSearch
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js